$(document).ready(function(){
	
	if(($.cookie('siteLocale', { path : '/' }) == null || $.cookie('siteLocale', { path : '/' }).length == 0 ) && locale != null){
		$.cookie('siteLocale', locale, { path : '/' });
	}
	if( ($.cookie('currency', { path : '/' }) == null || $.cookie('currency', { path : '/' }).length == 0) && Globals.currencyForCookie != null){
		$.cookie('currency', Globals.currencyForCookie, { expires : 365, path : '/' });
	}
	
	$("#live-chat").click(function() {
		/* provider-agnostic: chatwoot.tag registers window.IATIChat */
		if (window.IATIChat && window.IATIChat.open) { window.IATIChat.open(); }
		return false;
	});

});